import Vue from 'vue'
import Router from 'vue-router'
import lazyLoading from '../store/modules/menu/lazyLoading'

import menuModule from 'vuex-store/modules/menu'
import {cmsping} from '../application'

Vue.use(Router)

const demoRoutes = []
if (process.env.NODE_ENV === 'development') {
  const VueComponentTree = require('vue-component-tree').default

  demoRoutes.push(
    VueComponentTree(require.context('./..', true, /.demo.vue$/), '/demo')
  )
}

export default new Router({
  routes: [
    ...demoRoutes,
    ...generateRoutesFromMenu(menuModule.state.items),
    ...generateRoutesWithoutMenu(),
    {
      path: '*',
      redirect: { name: getDefaultRoute(menuModule.state.items).name }
    }
  ]
})

function generateRoutesWithoutMenu () {
  return [
    {
      name: 'Login',
      path: '/auth/login',
      component: lazyLoading('auth/login/Login'),
      meta: {
        default: false,
        title: 'menu.login',
        newWindow: true
      }
    },
  ]
}

function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      item.beforeEnter = (to, from, next) => {
        console.log('@@@@@beforeEnter', from, to)
        cmsping.get()
        next()
      }
      routes.push(item)
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}

function getDefaultRoute (menu = []) {
  let defaultRoute

  menu.forEach((item) => {
    if (item.meta.default) {
      defaultRoute = item
    } else if (item.children) {
      let defaultChild = item.children.find((i) => i.meta.default)
      defaultRoute = defaultChild || defaultRoute
    }
  })

  return defaultRoute
}



// WEBPACK FOOTER //
// ./src/router/index.js